/* Nukipet · comportamiento del tema. Sin dependencias. */
(function () {
  'use strict';
  const q = (s, r = document) => r.querySelector(s);
  const qa = (s, r = document) => Array.from(r.querySelectorAll(s));
  const N = window.nukipet || {};
  const rutas = N.rutas || {};
  const t = N.t || {};
  const reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fmt = (c) => {
    const plantilla = (N.moneda || 'S/ {{amount}}').replace(/<[^>]*>/g, '');
    const n = c / 100;
    const miles = (v, sep, dec) => { const [e, d] = v.toFixed(2).split('.'); return e.replace(/\B(?=(\d{3})+(?!\d))/g, sep) + (dec === null ? '' : dec + d); };
    let valor;
    if (plantilla.includes('amount_no_decimals_with_comma_separator')) valor = miles(n, '.', null);
    else if (plantilla.includes('amount_no_decimals_with_space_separator')) valor = miles(n, ' ', null);
    else if (plantilla.includes('amount_with_comma_separator')) valor = miles(n, '.', ',');
    else if (plantilla.includes('amount_with_space_separator')) valor = miles(n, ' ', ',');
    else if (plantilla.includes('amount_with_apostrophe_separator')) valor = miles(n, "'", '.');
    else if (plantilla.includes('amount_no_decimals')) valor = miles(n, ',', null);
    else valor = miles(n, ',', '.');
    return plantilla.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, valor);
  };

  /* Avisos */
  function avisar(texto, tono) {
    let caja = q('#avisos');
    if (!caja) { caja = document.createElement('div'); caja.id = 'avisos'; caja.className = 'avisos'; caja.setAttribute('aria-live', 'polite'); document.body.appendChild(caja); }
    const a = document.createElement('div');
    a.className = 'aviso' + (tono === 'error' ? ' aviso--error' : '');
    a.textContent = texto;
    caja.appendChild(a);
    setTimeout(() => a.remove(), 3600);
  }
  N.avisar = avisar;

  /* Capas: menú móvil y carrito */
  let ultimoFoco = null;
  function abrirCapa(capa) {
    if (!capa) return;
    ultimoFoco = document.activeElement;
    capa.hidden = false;
    document.documentElement.classList.add('bloqueado');
    const f = q('[data-foco-inicial]', capa) || q('button, a, input', capa);
    if (f) setTimeout(() => f.focus(), 30);
  }
  function cerrarCapa(capa) {
    if (!capa || capa.hidden || capa.classList.contains('cerrando')) return;
    const fin = () => { capa.classList.remove('cerrando'); capa.hidden = true; if (!qa('[data-capa]').some((c) => !c.hidden)) document.documentElement.classList.remove('bloqueado'); };
    if (reducido) fin(); else { capa.classList.add('cerrando'); setTimeout(fin, 270); }
    if (ultimoFoco && ultimoFoco.focus) ultimoFoco.focus();
  }
  document.addEventListener('click', (e) => {
    const abre = e.target.closest('[data-abrir]');
    if (abre) { const capa = document.getElementById(abre.getAttribute('data-abrir')); if (capa) { e.preventDefault(); abrirCapa(capa); abre.setAttribute('aria-expanded', 'true'); } return; }
    const cierra = e.target.closest('[data-cerrar]');
    if (cierra) { const capa = cierra.closest('[data-capa]'); cerrarCapa(capa); qa('[data-abrir="' + (capa && capa.id) + '"]').forEach((b) => b.setAttribute('aria-expanded', 'false')); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { qa('[data-capa]').forEach((c) => cerrarCapa(c)); const b = q('[data-buscador]'); if (b && !b.hidden) alternarBuscador(false); }
    if (e.key !== 'Tab') return;
    const capa = qa('[data-capa]').find((c) => !c.hidden);
    if (!capa) return;
    const f = qa('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])', capa).filter((x) => x.offsetParent !== null);
    if (!f.length) return;
    const primero = f[0]; const ultimo = f[f.length - 1];
    if (e.shiftKey && document.activeElement === primero) { e.preventDefault(); ultimo.focus(); }
    else if (!e.shiftKey && document.activeElement === ultimo) { e.preventDefault(); primero.focus(); }
  });

  /* Buscador con predictiva */
  function alternarBuscador(abrir) {
    const b = q('[data-buscador]'); const boton = q('[data-boton-buscar]');
    if (!b) return false;
    b.hidden = !abrir;
    if (boton) boton.setAttribute('aria-expanded', String(abrir));
    if (abrir) { const i = q('input[type="search"]', b); if (i) i.focus(); }
    return true;
  }
  document.addEventListener('click', (e) => {
    const boton = e.target.closest('[data-boton-buscar]');
    if (boton) { const b = q('[data-buscador]'); if (b) { e.preventDefault(); alternarBuscador(b.hidden); } }
  });
  let temporizador;
  qa('[data-predictiva-input]').forEach((input) => {
    const caja = document.getElementById(input.getAttribute('aria-controls'));
    if (!caja) return;
    input.addEventListener('input', () => {
      clearTimeout(temporizador);
      const termino = input.value.trim();
      if (termino.length < 2) { caja.innerHTML = ''; caja.hidden = true; return; }
      temporizador = setTimeout(async () => {
        try {
          const res = await fetch(rutas.predictiva + '?q=' + encodeURIComponent(termino) + '&resources[type]=product&resources[limit]=4&section_id=predictiva');
          if (!res.ok) return;
          const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
          const nuevo = q('[data-predictiva-resultados]', doc);
          caja.innerHTML = nuevo ? nuevo.innerHTML : '';
          caja.hidden = !caja.innerHTML.trim();
        } catch (err) { /* sin conexión: la búsqueda normal sigue funcionando */ }
      }, 220);
    });
  });
  qa('[data-limpiar-busqueda]').forEach((b) => b.addEventListener('click', () => { const i = b.closest('form').querySelector('input[type="search"]'); i.value = ''; i.focus(); i.dispatchEvent(new Event('input')); }));

  /* Carrito por secciones */
  const carrito = {
    capa() { return q('#carrito'); },
    async pedir(url, cuerpo) {
      const res = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(cuerpo) });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || t.error_carrito);
      return data;
    },
    pintar(html) {
      const capa = this.capa(); if (!capa || !html) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const nuevo = q('[data-carrito-contenido]', doc); const actual = q('[data-carrito-contenido]', capa);
      if (nuevo && actual) actual.innerHTML = nuevo.innerHTML;
      if (q('[data-carrito-pagina]')) window.location.reload();
    },
    contador(n) {
      qa('[data-carrito-contador]').forEach((el) => { el.textContent = n; el.hidden = n === 0; el.classList.remove('salta'); void el.offsetWidth; el.classList.add('salta'); });
      qa('[data-carrito-enlace]').forEach((a) => a.setAttribute('aria-label', t.carrito + ' (' + n + ')'));
    },
    async refrescar() {
      const data = await (await fetch(rutas.root + '?sections=carrito')).json();
      this.pintar(data.carrito);
      const c = await (await fetch(rutas.cart + '.js')).json();
      this.contador(c.item_count);
    },
    async agregar(items) {
      const data = await this.pedir(rutas.cart_add + '.js', { items, sections: 'carrito' });
      this.pintar(data.sections && data.sections.carrito);
      const c = await (await fetch(rutas.cart + '.js')).json();
      this.contador(c.item_count);
      return data;
    },
    async cambiar(key, cantidad) {
      const capa = this.capa(); if (capa) capa.classList.add('cargando');
      const pagina = q('[data-carrito-pagina]'); if (pagina) pagina.classList.add('cargando');
      try {
        const data = await this.pedir(rutas.cart_change + '.js', { id: key, quantity: cantidad, sections: 'carrito' });
        this.pintar(data.sections && data.sections.carrito);
        this.contador(data.item_count);
      } catch (err) { avisar(err.message, 'error'); }
      finally { if (capa) capa.classList.remove('cargando'); if (pagina) pagina.classList.remove('cargando'); }
    },
    async cupon(codigo, quitar) {
      const c = await (await fetch(rutas.cart + '.js')).json();
      const actuales = (c.discount_codes || []).map((d) => d.code);
      const lista = quitar ? actuales.filter((x) => x.toLowerCase() !== codigo.toLowerCase()) : Array.from(new Set(actuales.concat([codigo])));
      const data = await this.pedir(rutas.cart + '/update.js', { discount: lista.join(','), sections: 'carrito' });
      if (!quitar) {
        const ok = (data.discount_codes || []).find((d) => d.code.toLowerCase() === codigo.toLowerCase());
        if (!ok || !ok.applicable) { await this.pedir(rutas.cart + '/update.js', { discount: actuales.join(',') }); await this.refrescar(); return false; }
      }
      this.pintar(data.sections && data.sections.carrito);
      return true;
    },
    abrir() { const capa = this.capa(); if (capa && !q('[data-carrito-pagina]')) abrirCapa(capa); }
  };
  N.carrito = carrito;

  // Formularios de compra: ficha, tarjetas, packs, sugeridos del carrito
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-form-compra]');
    if (!form) return;
    e.preventDefault();
    const boton = e.submitter || q('[type="submit"]', form);
    const fd = new FormData(form);
    const items = [{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) }];
    qa('[data-extra]:checked', form).forEach((x) => items.push({ id: Number(x.value), quantity: 1 }));
    if (!items[0].id) { avisar(t.elige, 'error'); return; }
    if (boton) boton.classList.add('cargando');
    try {
      await carrito.agregar(items);
      if (boton && !form.closest('#carrito')) {
        const html = boton.innerHTML; boton.classList.add('agregado'); boton.textContent = t.agregado;
        setTimeout(() => { boton.classList.remove('agregado'); boton.innerHTML = html; }, 1600);
        volarAlCarrito(boton);
      }
      if (form.closest('#carrito')) return;
      if (!form.hasAttribute('data-sin-abrir')) setTimeout(() => carrito.abrir(), reducido ? 0 : 420);
      else avisar(t.agregado);
    } catch (err) { avisar(err.message, 'error'); }
    finally { if (boton) boton.classList.remove('cargando'); }
  });

  function volarAlCarrito(origen) {
    const destino = q('[data-carrito-enlace]'); if (!destino || reducido) return;
    const a = origen.getBoundingClientRect(); const b = destino.getBoundingClientRect();
    const bola = document.createElement('span'); bola.className = 'vuela';
    bola.style.left = (a.left + a.width / 2 - 7) + 'px'; bola.style.top = (a.top + a.height / 2 - 7) + 'px';
    document.body.appendChild(bola);
    requestAnimationFrame(() => { bola.style.transform = 'translate(' + (b.left + b.width / 2 - (a.left + a.width / 2)) + 'px, ' + (b.top + b.height / 2 - (a.top + a.height / 2)) + 'px) scale(0.4)'; bola.style.opacity = '0.2'; });
    setTimeout(() => bola.remove(), 800);
  }

  // Cantidades, quitar, cupón, icono del carrito (delegado: el contenido se repinta)
  document.addEventListener('click', async (e) => {
    const paso = e.target.closest('[data-paso]');
    if (paso) { const linea = paso.closest('[data-linea]'); const input = q('input', linea); carrito.cambiar(linea.getAttribute('data-linea'), Math.max(0, Number(input.value) + Number(paso.getAttribute('data-paso')))); return; }
    const quitar = e.target.closest('[data-quitar]');
    if (quitar) { carrito.cambiar(quitar.closest('[data-linea]').getAttribute('data-linea'), 0); return; }
    const sacar = e.target.closest('[data-quitar-cupon]');
    if (sacar) { e.preventDefault(); await carrito.cupon(sacar.getAttribute('data-quitar-cupon'), true); return; }
    const icono = e.target.closest('[data-carrito-enlace]');
    if (icono && carrito.capa() && !q('[data-carrito-pagina]')) { e.preventDefault(); carrito.abrir(); }
    const rec = e.target.closest('[data-abrir-recuperar]');
    if (rec) { e.preventDefault(); const r = q('#recuperar'); if (r) { r.classList.add('abierto'); q('input', r).focus(); } }
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-linea] input');
    if (input) carrito.cambiar(input.closest('[data-linea]').getAttribute('data-linea'), Math.max(0, Number(input.value) || 0));
  });
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-cupon]');
    if (!form) return;
    e.preventDefault();
    const input = q('input', form); const codigo = input.value.trim(); if (!codigo) return;
    const boton = q('button', form); boton.classList.add('cargando');
    try {
      const ok = await carrito.cupon(codigo);
      if (!ok) { const err = q('[data-cupon-error]'); if (err) { err.textContent = t.cupon_invalido.replace('__C__', codigo); err.hidden = false; } }
      else avisar(t.cupon_ok.replace('__C__', codigo));
    } catch (err) { avisar(err.message, 'error'); }
    finally { const b = q('[data-cupon] button'); if (b) b.classList.remove('cargando'); }
  });

  /* Selector de unidades: precio, total del botón, URL, barra fija */
  qa('[data-selector-pack]').forEach((form) => {
    const principal = form.hasAttribute('data-principal');
    const sincronizar = () => {
      const elegida = q('input[name="id"]:checked', form) || q('input[name="id"]', form);
      if (!elegida) return;
      qa('.unidad', form).forEach((o) => o.classList.toggle('elegida', o.contains(elegida)));
      let total = Number(elegida.getAttribute('data-precio') || 0);
      qa('[data-extra]:checked', form).forEach((x) => { total += Number(x.getAttribute('data-precio') || 0); });
      const cta = q('[data-cta-total]', form); if (cta && total) cta.textContent = fmt(total);
      if (!principal) return;
      const monto = q('[data-precio-monto]'); const antes = q('[data-precio-antes]'); const desc = q('[data-descuento]');
      if (monto && elegida.getAttribute('data-precio-texto')) monto.textContent = elegida.getAttribute('data-precio-texto');
      if (antes) { const a = elegida.getAttribute('data-antes'); if (a) { antes.lastChild.textContent = a; antes.hidden = false; } else antes.hidden = true; }
      if (desc) desc.hidden = !elegida.getAttribute('data-antes');
      const barra = q('[data-barra-compra]');
      if (barra) { const p = q('[data-barra-pack]', barra); const m = q('[data-barra-monto]', barra); if (p) p.textContent = elegida.getAttribute('data-rotulo') || ''; if (m && total) m.textContent = fmt(total); }
      if (elegida.getAttribute('data-rotulo') && window.history.replaceState) { const url = new URL(window.location.href); url.searchParams.set('variant', elegida.value); window.history.replaceState({}, '', url.toString()); }
    };
    form.addEventListener('change', sincronizar);
    sincronizar();
  });

  // Barra fija: aparece cuando el botón principal sale de la vista
  const cta = q('[data-cta-principal]'); const barra = q('[data-barra-compra]');
  if (cta && barra && 'IntersectionObserver' in window) {
    const pie = q('.pie');
    let ctaFuera = false; let pieVisible = false;
    const actualizar = () => { const v = ctaFuera && !pieVisible; barra.classList.toggle('visible', v); barra.setAttribute('aria-hidden', String(!v)); };
    new IntersectionObserver(([en]) => { ctaFuera = !en.isIntersecting && en.boundingClientRect.top < 0; actualizar(); }).observe(cta);
    if (pie) new IntersectionObserver(([en]) => { pieVisible = en.isIntersecting; actualizar(); }).observe(pie);
    q('[data-barra-boton]', barra).addEventListener('click', () => { const f = cta.closest('form'); if (f) f.requestSubmit(); });
  }

  /* Galería */
  qa('[data-galeria]').forEach((g) => {
    const slides = qa('[data-slide]', g); const minis = qa('[data-mini]', g); const pista = q('[data-pista]', g);
    const ir = (i) => {
      slides.forEach((s, k) => { s.classList.toggle('activa', k === i); s.setAttribute('aria-hidden', String(k !== i)); });
      minis.forEach((m, k) => m.setAttribute('aria-current', String(k === i)));
      if (minis[i]) minis[i].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: reducido ? 'auto' : 'smooth' });
    };
    minis.forEach((m, i) => m.addEventListener('click', () => ir(i)));
    const flechas = qa('[data-flecha]', g);
    const estado = () => {
      if (!pista) return;
      flechas.forEach((f) => { const d = Number(f.getAttribute('data-flecha')); f.disabled = d < 0 ? pista.scrollLeft <= 2 : pista.scrollLeft + pista.clientWidth >= pista.scrollWidth - 2; });
    };
    flechas.forEach((f) => f.addEventListener('click', () => pista.scrollBy({ left: Number(f.getAttribute('data-flecha')) * 84 * 3, behavior: reducido ? 'auto' : 'smooth' })));
    if (pista) { pista.addEventListener('scroll', estado, { passive: true }); estado(); }
    const form = q('[data-selector-pack][data-principal]');
    if (form) form.addEventListener('change', (e) => { const media = e.target.getAttribute && e.target.getAttribute('data-media'); if (!media) return; const i = slides.findIndex((s) => s.getAttribute('data-media-id') === media); if (i > -1) ir(i); });
    const principal = q('.galeria__principal', g);
    let x0 = null;
    if (principal) {
      principal.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
      principal.addEventListener('touchend', (e) => {
        if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) < 40) return;
        const actual = slides.findIndex((s) => s.classList.contains('activa'));
        ir(Math.min(slides.length - 1, Math.max(0, actual + (dx < 0 ? 1 : -1))));
      });
    }
  });

  /* Consentimiento obligatorio en formularios con casilla */
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form'); if (!form) return;
    const casilla = q('input[type="checkbox"][data-terminos]', form);
    if (casilla && !casilla.checked) { e.preventDefault(); avisar(t.acepta_terminos, 'error'); casilla.focus(); }
  });

  /* País por defecto en direcciones */
  qa('select[data-default]').forEach((s) => { const v = s.getAttribute('data-default'); if (v) s.value = v; });

  /* Cabecera con sombra y entradas al hacer scroll */
  const cabecera = q('.cabecera');
  if (cabecera) { const sombra = () => cabecera.classList.toggle('con-sombra', window.scrollY > 8); window.addEventListener('scroll', sombra, { passive: true }); sombra(); }
  if (!reducido && 'IntersectionObserver' in window) {
    const selector = '.encabezado, .card, .dato, .paso, .resena, .pack, .para-quien__tarjeta, .acordeon > details, .leads__caja, .como__media, .confianza__lista li, .specs__lista, .cifra';
    const items = qa(selector).filter((el) => !el.closest('.carrito, .menu-movil'));
    const visto = new IntersectionObserver((entradas) => { entradas.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('visible'); visto.unobserve(en.target); } }); }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach((el) => {
      const hermanos = Array.from(el.parentElement ? el.parentElement.children : []).filter((h) => h.matches(selector));
      el.style.setProperty('--i', Math.min(hermanos.indexOf(el), 6));
      el.setAttribute('data-revelar', '');
      visto.observe(el);
    });
    document.documentElement.classList.add('anima');
    requestAnimationFrame(() => items.forEach((el) => { const r = el.getBoundingClientRect(); if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('visible'); }));
  }

  /* Fotos: fundido al cargar */
  qa('img[loading="lazy"]').forEach((img) => {
    if (img.complete && img.naturalWidth) return;
    img.classList.add('por-cargar');
    const listo = () => { img.classList.remove('por-cargar'); img.classList.add('cargada'); };
    img.addEventListener('load', listo, { once: true }); img.addEventListener('error', listo, { once: true });
  });
})();
